import React from "react";

export default function MedalsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-zinc-800 p-4 sm:p-6 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto scrollbar-hide text-white relative"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        
        <h3 className="text-lg font-bold mb-4">Reglas</h3>
        <div className="text-sm space-y-2">
          <p>
            <strong>Viendo 5 películas por rubro</strong> ganarás una
            medalla y se desbloqueará una película clásica del rubro.
          </p>
          <p>
            <strong>Viendo 10 películas por rubro</strong> ganarás un
            trofeo y se desbloquearán 3 películas clásicas del rubro.
          </p>
          <p>
            <strong>Viendo 20 películas del rubro</strong> te convertirás
            en experto y podrás decidir en la selección de próximas
            películas.
          </p>
        </div>
        
        <button
          onClick={onClose}
          className="mt-6 px-4 py-2 bg-yellow-400 text-black rounded-full hover:bg-yellow-300 transition w-full"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
